<div id="app">
    <div id="layout">
        <div id="header-container" *ngIf="!isUnauthorized && !isLoading">
            <div id="app-header-container">
                <app-header></app-header>
            </div>
        </div>

        <div id="breadcrumbs-container" *ngIf="!isUnauthorized">
            <app-breadcrumbs></app-breadcrumbs>
        </div>

        <div id="content">
            <div id="app-loader" *ngIf="isLoading">
                <app-loader [globalLoader]="true"></app-loader>
            </div>
            <router-outlet></router-outlet>
            <app-error-page *ngIf="hasError && !isUnauthorized"></app-error-page>
            <app-unauthorized-page *ngIf="isUnauthorized"></app-unauthorized-page>
        </div>

        <div id="app-footer">
            <app-footer></app-footer>
        </div>
    </div>
</div>

<p-toast
    id="error-messages-anchor"
    position="top-center"
    [key]="toasterPositions.TOP_CENTER"
    [preventOpenDuplicates]="true">
</p-toast>
<p-toast
    id="warning-success-messages-anchor"
    position="bottom-right"
    [key]="toasterPositions.BOTTOM_RIGHT"
    [preventOpenDuplicates]="true">
</p-toast>
